import {GET_HEALTH_PLANS_REQUEST, 
    GET_HEALTH_PLANS_SUCCESS, 
    GET_HEALTH_PLANS_ERROR} from '../actions/type';

const initialState = {
    loading: null,
    error: null,
    data: null
}

// eslint-disable-next-line import/no-anonymous-default-export
export default (state=initialState, action) => {
    switch(action.type) {
        case GET_HEALTH_PLANS_REQUEST:
            return {
                ...state,
                loading: true
            }
        case GET_HEALTH_PLANS_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.data
            }
        case GET_HEALTH_PLANS_ERROR:
            return {
                ...state,
                loading: false,
                error: action.error
            }
        default:
            return state;
    }
}